import React from "react";
// Customizable Area Start
import { Box, Typography, Grid, styled } from "@material-ui/core";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";
import ViewLateDeliveryConfigController, { Props, configJSON } from "./ViewLateDeliveryConfigController.web";
// Customizable Area End

const theme = createTheme({});

export default class ViewLateDeliveryConfig extends ViewLateDeliveryConfigController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    const Strings = configJSON.LateDeliveryListPage.Strings;

    return (
      <ThemeProvider theme={theme}>
        <StyledMainBox>
          <Box>
            <CustomLoader loading={this.state.loading} />

            <Box className="titleContainer">
              <Typography className="titleContainerText">
                Late Delivery Configuration
              </Typography>
              <EditBtn onClick={this.handleEdit}>
                Edit
              </EditBtn>
            </Box>

            <Box className="addEditCard">
              <Box className="editInputBox">
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <HeadingText>Name</HeadingText>
                      <ValueText>{this.state.name}</ValueText>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <HeadingText>Hours</HeadingText>
                      <ValueText>{this.state.hours}</ValueText>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <HeadingText>Color</HeadingText>
                      <Box style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "12px" }}>
                        <Box
                          style={{
                            width: "32px",
                            height: "32px",
                            backgroundColor: this.state.color,
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          }}
                        />
                        <ValueText style={{ marginTop: 0 }}>{this.state.color}</ValueText>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <HeadingText>Status</HeadingText>
                      <ValueText
                        style={{
                          color: this.state.isActive ? "#059669" : "#DC2626",
                        }}
                      >
                        {this.state.isActive ? "Active" : "Inactive"}
                      </ValueText>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            <Box className="marginTop48">
              <BackBtn onClick={this.handleNavigateBack}>
                Back
              </BackBtn>
            </Box>
          </Box>
        </StyledMainBox>
      </ThemeProvider>
    );
    // Customizable Area End
  }
}

// Customizable Area Start
const StyledMainBox = styled(Box)({
  fontFamily: "Montserrat",
  padding: "32px",
  "& .titleContainer": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "32px",
  },
  "& .titleContainerText": {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "29px",
  },
  "& .addEditCard": {
    background: "#FFFFFF",
    borderRadius: "8px",
    padding: "24px",
  },
  "& .editInputBox": {
    width: "100%",
  },
  "& .marginTop48": {
    marginTop: "48px",
  },
});

const HeadingText = styled("div")({
  fontSize: 18,
  fontWeight: 600,
  lineHeight: "22px",
  color: "#4D4D4D",
  "@media only screen and (max-width: 1024px)": {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: "22px",
  },
});

const ValueText = styled("div")({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "22px",
  color: "#334155",
  marginTop: "12px",
  "@media only screen and (max-width: 1024px)": {
    fontSize: "13px",
    fontWeight: 500,
  },
});

const EditBtn = styled("button")({
  textTransform: "capitalize",
  padding: "16px 20px",
  borderRadius: "8px",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "24px",
  background: "#204B9C",
  color: "#FFFFFF",
  width: "184px",
  height: "56px",
  border: "none",
  cursor: "pointer",
  outline: "none",
  "@media only screen and (max-width: 1024px)": {
    padding: "10px 20px",
    width: "128px",
    fontSize: "13px",
    height: "44px",
  },
});

const BackBtn = styled("button")({
  textTransform: "capitalize",
  fontSize: "16px",
  padding: "16px 20px",
  borderRadius: "8px",
  background: "#204B9C",
  lineHeight: "24px",
  fontWeight: 700,
  color: "#FFFFFF",
  outline: "none",
  border: "none",
  width: "128px",
  height: "56px",
  cursor: "pointer",
  "@media only screen and (max-width: 1024px)": {
    width: "128px",
    fontSize: "13px",
    padding: "10px 20px",
    height: "44px",
  },
});
// Customizable Area End
